import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import config from '@/config';
import api from '@/shared/api';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
const fetchSites = (search) => api.base
    .get(`${config.appUrls.documents}/api/sharepoint/sites`, {
    params: search ? { search } : {},
})
    .then(x => (x.data || []).map((s) => ({ key: s.id, label: s.name })));
export const SharepointSiteAutoComplete = ({ value, onChange, onLoadingChanged, }) => {
    const loadSites = (search) => {
        onLoadingChanged === null || onLoadingChanged === void 0 ? void 0 : onLoadingChanged(true);
        return fetchSites(search).finally(() => onLoadingChanged === null || onLoadingChanged === void 0 ? void 0 : onLoadingChanged(false));
    };
    return (_jsx(AutoComplete, { mode: "edit", value: value, loadFunc: loadSites, loadOnInit: true, reloadOnClear: true, onChange: (item) => onChange(item !== null && item !== void 0 ? item : null) }));
};
